"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFallbackLocaleList = exports.FALLBACK_LOCALE_MAP = void 0;
const GetOverrideLocale_1 = require("../getOverrideLocale/GetOverrideLocale");
exports.FALLBACK_LOCALE_MAP = {
    "es-ES": "es",
    "fr-FR": "fr-CA",
};
function getFallbackLocaleList(envLocale = "en") {
    const validLocale = (0, GetOverrideLocale_1.getOverrideLocale)(envLocale);
    if (validLocale === "en") {
        return ["en"];
    }
    if (exports.FALLBACK_LOCALE_MAP[validLocale]) {
        return [validLocale, exports.FALLBACK_LOCALE_MAP[validLocale], "en"];
    }
    return [validLocale, "en"];
}
exports.getFallbackLocaleList = getFallbackLocaleList;
//# sourceMappingURL=GetFallbackLocaleList.js.map